import {Alert} from '@mui/material';
import {useZeroNeetAuth} from '../utils/useZeroNeetAuth';
import Dashboard2 from '../Dashboard2';

// "I nostri beneficiari" page — Dashboard 2 (Stato di avanzamento del percorso).
const ZeroNeetBeneficiaries = () => {
    const {container, uoaId, surveyIds, isAuthorized} = useZeroNeetAuth(['survey3_id', 'survey4_id']);

    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    return (
        <Dashboard2
            container={container!}
            uoaId={uoaId!}
            survey501Id={surveyIds.survey3_id!}
            survey502Id={surveyIds.survey4_id!}
        />
    );
};

export default ZeroNeetBeneficiaries;
